import React from 'react'
import { withNotifications } from 'redux/enhancers'

const REFRESH_INTERVAL = 5000

class Notifications extends React.Component {
  componentDidMount() {
    this.props.getUserNotices();
    this.interval = setInterval(this.props.getUserNotices, REFRESH_INTERVAL);
  }

  componentWillUnmount() {
    clearInterval(this.interval)
  }

  interval;

  render() {
    return null
  }
}

export default withNotifications(Notifications)
